import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
export const bugsnagClient = Bugsnag.start({
    apiKey: "aaa580f2011ac06c65ba1e8eb6eaf0fc",
    releaseStage: window.jrConfig.env,
    enabledReleaseStages: ["production", "beta"],
    enabledBreadcrumbTypes: [
        'navigation', 'request', 'process', 'log', 'user', 'state', 'error', 'manual'
    ],
    plugins: [
        new BugsnagPluginVue()
    ],
    onError: function(/* payload */) {
        var re = /^204\.79\.180/;
        if (window.jrConfig && window.jrConfig.clientIp && window.jrConfig.clientIp.match(re)) {
            return false;
        }
    }
});

window.$ = window.jQuery = require("jquery");

export function jrNotifyError(err, meta) {
    if (window.jrConfig.env != "production") {
        console.log(err);
        if (meta) {
            console.log(meta);
        }
    }
    bugsnagClient.notify(err, meta ? { metaData: { detail: meta } } : {});
}

export function jrNotifyEx(e, meta) {
    jrNotifyError(e, meta);
}

export function jrLeaveBreadcrumb(name, meta) {
    if (window.jrConfig.env != "production") {
        console.log(name, meta || {});
    }
    bugsnagClient.leaveBreadcrumb(name, meta);
}

jQuery.Deferred.exceptionHook = function(error, stack) {
    var shouldReport = true;

    // Add logic here to determine which errors should be reported to Bugsnag
    //    shouldReport = ???

    if (shouldReport) {
        jrNotifyEx(error);
    } else {
        console.log(error, stack);
    }
};

jQuery.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": jQuery('meta[name="csrf-token"]').attr("content")
    }
});

jQuery(document).ajaxError(function(event, jqxhr, settings, thrownError) {
    // Ignorable conditions
    if (
        jqxhr.status === 0 ||
        jqxhr.status === 400 ||
        jqxhr.status === 422 ||
        jqxhr.readyState === 0
    ) {
        jrLeaveBreadcrumb("AjaxError: " + jqxhr.status, thrownError);
    } else {
        jrNotifyError("AjaxError: " + jqxhr.status, { error: thrownError });
    }
});
jQuery(document).ajaxSend(function(event, jqxhr, settings) {
    const url = settings.url.toString();
    jrLeaveBreadcrumb("ajaxSend: " + url);
});
jQuery(document).ajaxComplete(function(event, jqxhr, settings) {
    const url = settings.url.toString();
    jrLeaveBreadcrumb("ajaxComplete: " + url);
});

// CORE VENDOR
require("bootstrap-sass");
require("./module/validation");

export const { $cm } = require("./module/cart-manager");
export const { $am } = require("./module/account-manager");

import {
    PromoManager,
    showSignupForm,
    hideSignupForm,
    promoFlowBannerShow,
    promoFlowBannerClose
} from "./module/promo-manager";

import {
    impressionsLoaded,
    productCompare,
    handleProductClick,
    isMobileDevice,
    leadConversion,
    loadVisible,
    sizechartBindings
} from "./module/util";

require("cookieconsent");

/*
export function ready (fn) {
  if (document.readyState != 'loading') {
    fn()
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', function () {
      fn()
    })
  } else {
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState != 'loading')
        fn()
    })
  }
}
*/

jQuery.ready.then(function() {

    function trackNavClick(category) {
        return function(ev) {
            var action = "Click";
            var label = $(this).attr("title") || $(ev.target).text();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "GAEvent",
                eventCategory: category,
                eventAction: category + "-" + action,
                eventLabel: category + "-" + action + "-" + label,
                eventValue: ""
            });
        };
    }

    // track menu clicks
    $(".side_menu")
        .find("a")
        .click(trackNavClick("SideMenu"));
    $("footer")
        .find("a")
        .click(trackNavClick("FooterMenu"));
    $("#jr-header-menu")
        .find("a")
        .click(trackNavClick("TopMenu"));
    $(".breadcrumb")
        .find("a")
        .click(trackNavClick("Breadcrumb"));
    $(".blog")
        .find("a")
        .click(trackNavClick("Blog"));

    //add hovering for product listing swatch images
    $(".prod-image-color").mouseenter(function() {
        var prodid =
            $(this).attr("data-prodid") ||
            $(this)
                .closest("div[data-prodid]")
                .attr("data-prodid");
        var url = $(this).data("alt-image");
        if (url && prodid) {
            $("#products-list-" + prodid).attr("src", url);

            // Color adjust urls within our container
            const tileRoot = $(this).closest("div[data-prodid]");
            tileRoot.find(".href-color-adjust").attr("href", $(this).attr("href"));
            if ($(this).data("on-sale")) {
                tileRoot.find(".ribbon").show();
            } else {
                tileRoot.find(".ribbon").hide();
            }
        }
    });

    $(".prod-click").click(handleProductClick);
    impressionsLoaded();

    $(".product-compare input").change(productCompare);
    productCompare();

    $(window).scroll(loadVisible);
    loadVisible();

    function showGenericModal(item, complete) {
        var url = item.data("content");
        if (url) {
            $("#genericModal")
                .find(".modal-content")
                .load(url, function() {
                    if (complete) {
                        complete();
                    }
                    $("#genericModal").modal();
                });
        }
    }

    // Fill modal with content from link href
    $(".generic-modal").click(function(e) {
        e.preventDefault();
        $("#genericModal").removeClass("fit-guide-modal");
        $("#genericModal").removeClass("fit-guide-modal-bra");
        showGenericModal($(this));
        return false;
    });

    $(".sizechart-modal").click(function(e) {
        e.preventDefault();
        $("#genericModal").removeClass("fit-guide-modal");
        $("#genericModal").removeClass("fit-guide-modal-bra");
        $("#genericModal").addClass(
            $(this).data("size") ? "fit-guide-modal" : "fit-guide-modal-bra"
        );
        showGenericModal($(this), function() {
            sizechartBindings();
        });
        return false;
    });

    $("form[data-promo-route]").each(function() {
        new PromoManager(
            $(this).data("promo-route"),
            'form[name="' + $(this).attr("name") + '"]',
            $(this).data("promo-category"),
            $(this).data("promo-label")
        );
    });

    $("img[data-src]").each(function() {
        $(this)
            .attr("src", $(this).data("src"))
            .removeData("src");
    });

    if (!isMobileDevice()) {
        $(".signup-toggle-text").html("Click here");
    }
    $(".signup-toggle-close").click(hideSignupForm);
    $(".signup-toggle").click(function() {
        if ($(".signup-form").is(":visible")) {
            hideSignupForm();
        } else {
            showSignupForm();
        }
    });
    $(".promo-flow-action").click(function() {
        $(".promo-flow-banner").slideUp();
        $("#promoModal").modal();
    });

    $("#promoModal").on("hidden.bs.modal", function() {
        promoFlowBannerShow();
    });

    $("#ouibounce-modal .ouibounce-close").on("click", function() {
        $("#ouibounce-modal").hide();
    });

    $(".promo-close").on("click", promoFlowBannerClose);

    function ouibounceError(msg) {
        $("#ouibounce-modal button").show();
        $("#ouibounce-modal form i").hide();
        $("#ouibounce-modal .error")
            .parent()
            .addClass("has-error");
        $("#ouibounce-modal .error").html(msg);
    }

    $("#ouibounce-modal form").validate({
        submitHandler: function(form) {
            var data = $(form).serialize();
            $("#ouibounce-modal .error").html("");
            $("#ouibounce-modal button").hide();
            $("#ouibounce-modal form i").show();
            $.post("/api/promo/signup", data, function(resp) {
                if (resp.success) {
                    leadConversion("email_popup");
                    $("#ouibounce-modal .signup").hide();
                    $("#ouibounce-modal .confirm").show();
                } else {
                    ouibounceError("Request failed.  Try again later.");
                }
                $(".promo-flow-banner").remove();
            }).fail(function(jqXHR) {
                var resp = jqXHR.responseJSON || {
                    error: { message: "Request failed.  Try again later." }
                };
                if (jqXHR.status == 422 && resp.email) {
                    ouibounceError(resp.email.join("<br>"));
                } else if (resp.error.message == "Email exists") {
                    ouibounceError("A customer with this email already exists!");
                } else {
                    ouibounceError(resp.error.message);
                }
                $(".promo-flow-banner").remove();
            });
        }
    });

    if (window.jrConfig.promoModal && window.jrConfig.promoStage == 0) {
        if (!isMobileDevice()) {
            $("#promoModal").modal();
        }
    } else {
        // Check for ouibounce, in a short bit
        window.setTimeout(function() {
            if (window.jrConfig.ouibounce) {
                const ouibounce = require("ouibounce");
                var x = ouibounce($("#ouibounce-modal")[0], {
                    cookieExpire: 365,
                    cookieDomain: window.jrConfig.domain,
                    sitewide: true,
                    callback: function() {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "GAEvent",
                            eventCategory: "email_popup",
                            eventAction: "view",
                            eventLabel: "",
                            eventValue: ""
                        });
                    }
                });
                if (isMobileDevice() || $(".promo-flow-banner").length == 0) {
                    x.disable();
                } else {
                    x.fire();
                }
            }
        }, 5000);
    }

    sizechartBindings();

    let triggerCookies = true;
    function setCookieUsage(allow) {
        triggerCookies = false;
        window.dataLayer = window.dataLayer || [];
        if (allow) {
            // enable cookies
            window.dataLayer.push({
                event: "GAEvent",
                eventCategory: "CookieConsent",
                eventAction: "enable",
                eventLabel: "",
                eventValue: ""
            });
        } else {
            // disable cookies
            window.dataLayer.push({
                event: "GAEvent",
                eventCategory: "CookieConsent",
                eventAction: "disable",
                eventLabel: "",
                eventValue: ""
            });
        }
    }

    function handleCookieOption(type, didConsent) {
        if (type == "info") {
            setCookieUsage(true);
        } else if (type == "opt-in") {
            setCookieUsage(didConsent);
        } else if (type == "opt-out") {
            setCookieUsage(!didConsent ? false : true);
        }
    }

    window.cookieconsent.initialise(
        {
            // container: document.getElementById("content"),

            content: {
                header: "Cookies used on the website!",
                message:
                    "Julianna Rae uses cookies to provide you with the best possible user experience. ",
                dismiss: "Got it!",
                allow: "Allow cookies",
                deny: "Decline",
                link: "Learn More",
                href: "/help/cookie-policy", // 'http://cookiesandyou.com',
                close: "&#x274c;"
            },

            palette: {
                popup: { background: "#fff" },
                button: { background: "#990033" }
            },

            layout: "basic",

            theme: "block",

            revokable: false,

            type: "info",

            position: "bottom",

            cookie: {
                expiryDays: 3650
            },

            onPopupOpen: function() {
                // triggerCookies = false
            },

            onInitialise: function(/* status */) {
                handleCookieOption(this.options.type, this.hasConsented());
            },

            onStatusChange: function(/* status */) {
                handleCookieOption(this.options.type, this.hasConsented());
            },

            onRevokeChoice: function() {
                var type = this.options.type;
                if (type == "opt-in") {
                    setCookieUsage(false);
                }
                if (type == "opt-out") {
                    setCookieUsage(true);
                }
            },

            law: {
                regionalLaw: true
            },

            location: false
        },
        function() {
            // If no decision yet, assume cookies are OK
            if (triggerCookies) {
                setCookieUsage(true);
            }
        }
    );
});
